import Agreements from "../agreements/agreements";

const Disclaimer = ({ modalDisclaimer }) => {
  // make the previous data format of modalDisclaimer compatible
  let contentNode;
  if (typeof modalDisclaimer === "object") {
    contentNode = modalDisclaimer;
  } else {
    contentNode = <Agreements agreements={modalDisclaimer} />;
  }

  return contentNode;
};

export default Disclaimer;
